export default [
    {
        path: '/wxtp/app',
        meta: {
            authCode: "wxtp-manage",
            forceCheckAuth: true //强制检查权限,即使当前用户是admin,也要校验权限
        },
        component: (resolve) => require(['./AppList.vue'], resolve),
    }
]



// WEBPACK FOOTER //
// ./src/modules/wxtp/router.js